import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import signupActions from 'redux/actions/signupActions'
import confirmTypes from 'helpers/enums/confirmTypes'
import generalActions from 'redux/actions/generalActions'
import { localize } from 'helpers/translator'


const CONFIRM_TYPE = confirmTypes.SIGNUP_STUDENT_VALIDATION

const BinderDeleteConfirm = props => (<Confirm
	btOne={localize('global_joinALesson')}
	btTwo={localize('global_signUp')}
	alertTitle={localize('global_areYouStudent_question')}
	alertMessage={localize('signUp_studentAlertMessage')}
	actionButtonType={0}
	actionOne={() => {
		props.actions.studentConfirmed()
		props.actions.closeConfirm(CONFIRM_TYPE)
	}
	}
	actionTwo={
		() => {
			props.actions.teacherConfirmed()
			props.actions.closeConfirm(CONFIRM_TYPE)
		}
	}
	closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
/>)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		studentConfirmed: signupActions.studentConfirmed,
		teacherConfirmed: signupActions.teacherConfirmed,
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(BinderDeleteConfirm)
